export const DEFAULT_CONFIG_NAME = 'Unsaved configuration';

export const MODEL_SETTINGS_MODAL_TITLE = 'Model Configuration';
export const MODEL_SETTINGS_MODAL_SUBTITLE =
  'Create and save model configurations to use across prompts in your workspace.';
